var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dishes"},[_c('dish-filter',{on:{"create-dish":_vm.openModal}}),_c('dish-table'),_c('dish-modal',{attrs:{"show":_vm.showModal},on:{"update:show":function($event){_vm.showModal=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }